import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { NbRangepickerComponent } from '@nebular/theme/components/datepicker/datepicker.component';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { Filter } from '../../../../shared/constants/Filters';
import { DashboardFilter } from '../../../../shared/models/company/dashboardFilter';
import { DashboardComunicationService } from '../../../dashboard/dashboard/dashboard-comunication.service';
import { BrandSelectionDropdownComponent } from '../../dropdown/brand-selection-dropdown/brand-selection-dropdown.component';
import { ChannelSelectionDropdownComponent } from '../../dropdown/channel-selection-dropdown/channel-selection-dropdown.component';
import { CompanySelectionDropdownComponent } from '../../dropdown/company-selection-dropdown/company-selection-dropdown.component';
import { TypeSelectionDropdownComponent } from '../../dropdown/type-selection-dropdown/type-selection-dropdown.component';

// TODO All filters use the LeadFiltersComponent.
@Component({
  selector: 'ngx-dashboard-filter',
  templateUrl: './dashboard-filter.component.html',
  styles: [`
  @media only screen and (max-width: 991px) {
    :host ::ng-deep ngx-daterangepicker-material {
      right: 50vw;
    }
  }

  @media only screen and (max-width: 480px) {
    :host ::ng-deep ngx-daterangepicker-material {
      right: 75vw;
    }
  }

  :host ::ng-deep ngx-daterangepicker-material {
    position: absolute;
  }

  :host ::ng-deep .calendar.right {
    display: none !important;
  }
`]
})
export class DashboardFilterComponent implements AfterViewInit {

  filter: DashboardFilter = new DashboardFilter();

  @ViewChild(BrandSelectionDropdownComponent, { static: false }) brandSelectionComponent: BrandSelectionDropdownComponent;
  @ViewChild(ChannelSelectionDropdownComponent, { static: false }) channelSelectionComponent: ChannelSelectionDropdownComponent;
  @ViewChild(TypeSelectionDropdownComponent, { static: false }) typesSelectionComponent: TypeSelectionDropdownComponent;
  @ViewChild(CompanySelectionDropdownComponent, { static: false }) companiesSelectionComponent: CompanySelectionDropdownComponent;
  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;
  @ViewChild(NbRangepickerComponent, { static: false }) createDatePicker: NbRangepickerComponent<Date>;
  @ViewChild(NbRangepickerComponent, { static: false }) updatedDatePicker: NbRangepickerComponent<Date>;

  picker: DaterangepickerComponent;

  filterDate: string;
  today = moment();
  createdAtFrom: NgbDate;
  createdAtTo: NgbDate;
  filterAfterSale: boolean;
  filterVn: boolean;
  filterVo: boolean;
  filterUnknow: boolean;
  rangeSelected: string;
  dateModel: string;
  filterForTable: any = {};
  sending: boolean;
  isPageLoaded: any;
  rangeCreate: { start: Date; end: Date; };
  rangeUpdate: { start: Date; end: Date; };
  brandsSelected: any;
  channelsSelected: any;
  typesSelected: any;
  companySelected: any;

  constructor(private readonly dashboardComuService: DashboardComunicationService) {
    this.sending = false;
    this.rangeCreate = { start: null, end: null };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isPageLoaded = true;
      this.generateFilterFromLocalStorage();
      this.applyFilter();
    });
  }

  applyFilter(): void {
    this.sending = true;
    // this.filter.brands = this.brandSelectionComponent.selectedItems.map(brand => brand.id);
    // this.filter.channels = this.channelSelectionComponent.selectedItems.map(channel => channel.id);
    // this.filter.leadTypes = this.typesSelectionComponent.selectedItems.map(type => type.id);
    this.filter.companies = this.companiesSelectionComponent.selectedItems.map(company => company.id);

    this.createDateRangeForFilter();

    if (this.createdAtFrom) {
      this.filter.createdAtFrom = new Date(this.createdAtFrom.year,
        this.createdAtFrom.month - 1,
        this.createdAtFrom.day);
    }

    if (this.createdAtTo) {
      this.filter.createdAtTo = new Date(this.createdAtTo.year,
        this.createdAtTo.month - 1,
        this.createdAtTo.day, 23, 59, 59);
    }

    const filterForView = {
      brands: this.brandSelectionComponent.selectedItems,
      channels: this.channelSelectionComponent.selectedItems,
      leadTypes: this.typesSelectionComponent.selectedItems,
      filterDate: this.dateModel
    };

    this.dashboardComuService.applyFilter(this.filter, filterForView);
    this.saveFilter();
    this.sending = false;

  }
  saveFilter(): void {
    const filterSave = {
      companiesSelectionComponentSelectedItems: this.companiesSelectionComponent.selectedItems,
      brandSelectionComponentSelectedItems: this.brandSelectionComponent.selectedItems,
      channelSelectionComponentSelectedItems: this.channelSelectionComponent.selectedItems,
      typesSelectionComponentSelectedItems: this.typesSelectionComponent.selectedItems,
      createdAtFrom: this.createdAtFrom,
      createdAtTo: this.createdAtTo,
      startDateFilter: this.rangeCreate.start,
      endDateFilter: this.rangeCreate.end,
      dateModel: this.dateModel,
      rangeSelected: this.rangeSelected,
      rangeCreate: this.rangeCreate,
    };
    localStorage.setItem(Filter.DASHBOARD, JSON.stringify(filterSave));
  }

  generateFilterFromLocalStorage(): void {
    const filterLocalStorage = JSON.parse(localStorage.getItem(Filter.DASHBOARD));
    if (!filterLocalStorage) {
      return;
    }
    this.companiesSelectionComponent.selectedItems = filterLocalStorage.companiesSelectionComponentSelectedItems;
    this.companySelected = filterLocalStorage.companiesSelectionComponentSelectedItems;
    this.brandSelectionComponent.selectedItems = filterLocalStorage.brandSelectionComponentSelectedItems;
    this.brandsSelected = filterLocalStorage.brandSelectionComponentSelectedItems;
    this.channelSelectionComponent.selectedItems = filterLocalStorage.channelSelectionComponentSelectedItems;
    this.channelsSelected = filterLocalStorage.channelSelectionComponentSelectedItems;
    this.typesSelectionComponent.selectedItems = filterLocalStorage.typesSelectionComponentSelectedItems;
    this.typesSelected = filterLocalStorage.typesSelectionComponentSelectedItems;
    this.createdAtFrom = filterLocalStorage.createdAtFrom;
    this.createdAtTo = filterLocalStorage.createdAtTo;
    this.dateModel = filterLocalStorage.dateModel;
    this.rangeSelected = filterLocalStorage.rangeSelected;
    this.rangeCreate = {
      start: filterLocalStorage.startDateFilter ? new Date(filterLocalStorage.startDateFilter) : null,
      end: filterLocalStorage.endDateFilter ? new Date(filterLocalStorage.endDateFilter) : null
    };
  }

  selectDateFilter(amount: any, filter?: string): void {
    this.rangeSelected = '';
    this.filterDate = filter;
    const newdate = moment()
      .subtract(amount, 'days');

    this.createdAtTo = filter === 'yesterday' ?
      new NgbDate(newdate.year(), newdate.month() + 1, newdate.date()) :
      new NgbDate(this.today.year(), this.today.month() + 1, this.today.date());

    this.createdAtFrom = new NgbDate(newdate.year(), newdate.month() + 1, newdate.date());
  }

  clearDateFilter(): void {
    this.filterDate = '';
    this.createdAtFrom = null;
    this.createdAtTo = null;
    this.rangeSelected = '';
    this.dateModel = '';
    this.filter.createdAtTo = null;
    this.filter.createdAtFrom = null;
    this.rangeCreate = { start: null, end: null };
    this.rangeSelected = '';
  }

  applyRangeDate(range: any): void {
    this.createdAtFrom = new NgbDate(range.startDate.year(), range.startDate.month() + 1, range.startDate.date());
    this.createdAtTo = new NgbDate(range.endDate.year(), range.endDate.month() + 1, range.endDate.date());
    this.rangeSelected = `${range.startDate.format('D/M/YYYY')} - ${range.endDate.format('D/M/YYYY')}`;
  }

  haveFiltersApplied(): any {
    if (!this.isPageLoaded) {
      return false;
    }

    return this.filterVo ||
      this.filterVn ||
      this.filterAfterSale ||
      this.filterUnknow ||
      this.createdAtTo ||
      this.createdAtFrom ||
      this.rangeSelected ||
      (this.brandSelectionComponent && this.brandSelectionComponent.selectedItems.length > 0) ||
      (this.typesSelectionComponent && this.typesSelectionComponent.selectedItems.length > 0) ||
      (this.companiesSelectionComponent && this.companiesSelectionComponent.selectedItems.length > 0) ||
      (this.channelSelectionComponent && this.channelSelectionComponent.selectedItems.length > 0);
  }

  clearFilter(): void {
    this.filter = new DashboardFilter();
    this.brandSelectionComponent.selectedItems = [];
    this.channelSelectionComponent.selectedItems = [];
    this.typesSelectionComponent.selectedItems = [];
    this.companiesSelectionComponent.selectedItems = [];
    localStorage.removeItem(Filter.DASHBOARD);
    this.clearDateFilter();
  }

  resetFilter(): void {
    this.clearFilter();
    this.applyFilter();
  }

  createdDateRangeChange(range): void {
    let endDate = '?';
    if (range.end) {
      endDate = moment(range.end).format('D/M/YYYY');
    }
    this.rangeSelected = `${moment(range.start).format('D/M/YYYY')} - ${endDate}`;
  }

  createDateRangeForFilter(): void {
    if (this.rangeCreate.start) {
      this.filter.createdAtFrom = this.rangeCreate.start;
      if (!this.rangeCreate.end) {
        this.rangeCreate.end = new Date(this.rangeCreate.start);
        this.rangeSelected = `${moment(this.rangeCreate.start).format('D/M/YYYY')} - ${moment(this.rangeCreate.end).format('D/M/YYYY')}`;
      }
      this.rangeCreate.end.setHours(23, 59, 59);
      this.filter.createdAtTo = this.rangeCreate.end;
    }
  }
}
